import { render, staticRenderFns } from "./_popupList.vue?vue&type=template&id=487b3f51&"
import script from "./_popupList.vue?vue&type=script&lang=js&"
export * from "./_popupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports